<template>
  <div class="multimedia__block">
    <div class="multimedia__content">
      <slot></slot>
    </div>
    <div class="multimedia__navigation">
      <div class="multimedia__navigation-list">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="[
            { 'is-active': tab.isActive },
            `multimedia__navigation-item--bg-${index}`,
            {
              'multimedia__navigation-item--bg-custom':
                tab.name === $t('multimedia.custom'),
            },
          ]"
          :title="tab.name"
          @click="selectTab(tab)"
          class="multimedia__navigation-item"
          role="button"
        >
          <div v-if="tab.hasIcon" class="multimedia__navigation-item-icon" v-tooltip="tab.name">
            <component :is="tab.icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TypeAttachIcon from '@/assets/icons/type-attach.svg';
import TypeDocumentIcon from '@/assets/icons/type-document.svg';
import TypeImageIcon from '@/assets/icons/type-image.svg';
import TypeLocationIcon from '@/assets/icons/type-location.svg';
import TypeTextIcon from '@/assets/icons/type-text.svg';
import TypeVideoIcon from '@/assets/icons/type-video.svg';
import TypeTemplateIcon from '@/assets/icons/type-template.svg';

export default {
  components: {
    TypeAttachIcon,
    TypeDocumentIcon,
    TypeImageIcon,
    TypeLocationIcon,
    TypeTextIcon,
    TypeVideoIcon,
    TypeTemplateIcon,
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  computed: {
    ...mapState({
      selectedCampaign: (state) => state.currentCampaign,
    }),
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        // eslint-disable-next-line no-param-reassign
        tab.isActive = tab.name === selectedTab.name;
      });
      this.$emit('change-tab', selectedTab);
    },
  },
};
</script>
